module.exports = __webpack_public_path__ + "img/Team-RachelMoses.71d48631.png";